import { computed } from 'vue'

import { useAuthStore } from '@/features/auth/useAuthStore.js'
import { getActiveClubDisplayName } from '@/features/router/useActiveClub.js'

export function useClubList() {
  const authStore = useAuthStore()
  const clubs = computed(() => {
    const myTenants = authStore.myDetails?.myTenants || []

    return myTenants.map(item => {
      const displayName = getActiveClubDisplayName(item)

      return {
        id: item.tenantId,
        name: displayName === 'N/A' ? item.name : displayName,
        description: item.description,
        isRegisteredFinalized: item.isRegisteredFinalized,
      }
    })
  })

  return {
    clubs,
  }
}
